module.exports = __webpack_public_path__ + "static/media/openflow.5608b2aa.png";